<template>
  <div class="service-page">
    <!-- 搜索条 + 市选择（市单独一行） -->
    <div class="search-toolbar">
      <div class="search-bar">
        <div class="search-input">
          <img
            src="@/assets/image/search1.png"
            alt="搜索"
            class="search-icon"
          >
          <input
            v-model="keyword"
            type="text"
            placeholder="输入关键词搜索"
            @keyup.enter="handleSearch"
          >
        </div>
        <button
          class="search-btn"
          @click="handleSearch"
        >搜索</button>
      </div>
      <div class="region-city-row">
        <region-city-picker />
      </div>
    </div>

    <!-- 标题 + 列表（统一白底容器） -->
    <div class="list-section">
      <div class="section-header">
        <img
          src="@/assets/image/al/zjs2.png"
          alt="造价师"
          class="section-icon"
        >
        <span class="section-title">造价师服务</span>
      </div>

      <!-- 列表 -->
      <div v-if="loading" class="loading-text">加载中...</div>
      <div v-else-if="filteredEngineers.length === 0" class="no-data">暂无造价师数据</div>
      <div v-else class="engineer-grid">
        <div
          v-for="item in filteredEngineers"
          :key="item.id"
          class="engineer-card"
          @click="goToCaseNews(item)"
        >
          <div class="card-cover">
            <img
              :src="$getImageUrl(item.avatar)"
              :alt="item.name"
            >
            <div v-if="item.certification_status === 1" class="badge">
              <img
                :src="require('@/assets/image/al/zjs1.png')"
                alt="认证"
              >
              <span>{{ item.certification_text }}</span>
            </div>
          </div>
          <div class="card-body">
            <div class="row top">
              <div class="label">{{ item.name }}</div>
              <div class="tag">{{ item.title }}</div>
            </div>
            <div class="row">
              <div class="label">{{ item.work_start_time_text ? `从业: ${item.work_start_time_text.split(' ')[0]}` : '专业造价师' }}</div>
              <div class="stars">
                <img
                  v-for="n in Math.floor(item.rating)"
                  :key="'y'+item.id+n"
                  src="@/assets/image/scy.png"
                  alt="星"
                >
                <img
                  v-for="n in (5-Math.floor(item.rating))"
                  :key="'n'+item.id+n"
                  src="@/assets/image/scn.png"
                  alt="星"
                >
              </div>
            </div>
            <div class="desc">{{ item.introduction }}</div>
            <div class="consultation-info">
              <span class="consultation-count">咨询次数: {{ item.consultation_count }}</span>
              <span v-if="item.online_status === 1" class="online-status">在线</span>
              <span v-else class="offline-status">离线</span>
            </div>
            <button class="btn" @click.stop="goConsult(item)">立即咨询</button>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <el-pagination
        v-if="total > 0"
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        class="pagination"
        @current-change="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import { getEngineerList } from '@/api/user'
import RegionCityPicker from '@/components/RegionCityPicker.vue'

export default {
  name: 'Service',
  components: { RegionCityPicker },
  data() {
    return {
      keyword: '',
      engineers: [],
      loading: false,
      currentPage: 1,
      pageSize: 12,
      total: 0
    }
  },
  computed: {
    filteredEngineers() {
      return this.engineers
    }
  },
  created() {
    this.fetchEngineers()
  },
  mounted() {
    window.addEventListener('region-changed', this.handleRegionChanged)
  },
  beforeDestroy() {
    window.removeEventListener('region-changed', this.handleRegionChanged)
  },
  methods: {
    handleRegionChanged() {
      this.currentPage = 1
      this.fetchEngineers()
    },
    async fetchEngineers() {
      try {
        this.loading = true
        const params = {
          keyword: this.keyword,
          page: this.currentPage,
          limit: this.pageSize
        }
        const response = await getEngineerList(params)
        if (response && response.data && response.data.list) {
          this.engineers = response.data.list.map(item => ({
            id: item.id,
            name: item.name,
            title: item.title || '造价师',
            avatar: item.avatar,
            rating: parseFloat(item.rating) || 0,
            introduction: item.introduction || '从事工程造价行业，具有丰富的行业经验。',
            consultation_count: item.consultation_count || 0,
            online_status: item.online_status,
            certification_status: item.certification_status,
            enterprise_certification: item.enterprise_certification,
            work_start_time_text: item.work_start_time_text,
            rating_text: item.rating_text,
            certification_text: item.certification_text,
            enterprise_text: item.enterprise_text
          }))
          this.total = response.data.pagination ? response.data.pagination.total : 0
        }
      } catch (error) {
        console.error('获取造价师列表失败:', error)
        this.engineers = []
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchEngineers()
    },
    handlePageChange(page) {
      this.currentPage = page
      this.fetchEngineers()
    },
    goToCaseNews(item) {
      this.$router.push({
        path: '/service/detail',
        query: { id: item.id }
      })
    },
    goConsult(item) {
      // 检查登录状态
      const { checkAuth } = require('@/utils/auth')
      if (!checkAuth(this.$router, '请先登录后再进行咨询')) {
        return
      }
      this.$router.push({
        path: '/consulting/index',
        query: { cost_engineer_id: item.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.service-page {
  width: var(--page-wide-ratio, 75%);
  max-width: 1400px;
  margin: 0 auto;
}

.search-toolbar {
  margin: 20px 0;
}

.search-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;

  .search-input {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #f39800;
    border-radius: 10px;
    padding: 0 15px;
    width: 100%;
    /* 与列表保持一致宽度 */
    border-right: none;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    .search-icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
    input {
      border: none;
      outline: none;
      height: 60px;
      width: 100%;
      font-size: 14px;
    }
  }

  .search-btn {
    background: #f39800;
    color: #fff;
    border: none;
    width: 160px;
    height: 62px;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}

.region-city-row {
  width: 100%;
  margin-top: 12px;
}

.list-section { background:#fff; padding:20px; border-radius:8px; box-shadow:0 2px 8px rgba(0,0,0,0.08); }
.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 10px 0 14px;
}
.section-icon {
  width: 20px;
  height: 20px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
}

.engineer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.engineer-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.card-cover {
  position: relative;
}
.card-cover img {
  width: 100%;
  height: 200px;
  object-fit: contain;
  background: #f5f7fa;
  display: block;
}
.badge {
  position: absolute;
  right: 8px;
  top: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 4px 8px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}
.badge img {
  width: 14px;
  height: 14px;
}
.card-body {
  padding: 12px;
}
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.row.top .label {
  font-weight: 600;
}
.tag {
  background: #eef4ff;
  color: #3178f6;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
}
.stars img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.desc {
  color: #666;
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btn {
  width: 100%;
  height: 36px;
  border: none;
  background: #0f70e2;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}

.loading-text, .no-data {
  text-align: center;
  color: #999;
  padding: 40px;
  font-size: 14px;
}

.consultation-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0;
  font-size: 12px;
}

.consultation-count {
  color: #666;
}

.online-status {
  color: #52c41a;
  font-weight: 500;
}

.offline-status {
  color: #999;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}

@media (max-width: 1600px) {
  .service-page {
    width: 92%;
    max-width: none;
  }

  .search-bar .search-input input {
    height: 52px;
  }

  .engineer-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 1366px) {
  .service-page {
    width: 96%;
  }

  .engineer-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  .engineer-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 768px) {
  .engineer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 480px) {
  .engineer-grid {
    grid-template-columns: 1fr;
  }
}
</style>
